import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { range } from 'lodash-es';
import pluralize from 'pluralize';
import { GridItem, WithInfoIcon, Checkbox, Typography, Select, MenuItem, useDevice } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import styles from './ExpirationDate.module.scss';
const dayOptions = ()=>range(1, 91);
const pluralizeDay = (day)=>pluralize('day', day, true);
const noneOption = {
    value: '-1',
    label: 'Not set'
};
const ExpirationDate = (param)=>{
    let { daysToExpiration, hasExpirationDate, disabled, setDaysToExpiration, setHasExpirationDate } = param;
    const { t: texts } = useLocaleKeys('components.agreementStudio.expirationDate');
    const { isMobileDevice } = useDevice();
    const commonSelectProps = {
        collapseHelperText: false,
        mobile: {
            renderAsCard: true
        },
        size: 'small',
        width: 70,
        disabled,
        value: daysToExpiration,
        menuMaxHeight: 400,
        testId: 'expiration-days-select'
    };
    const commonMenuItemProps = (day)=>({
            testId: "expiration-days-select-item-".concat(day),
            value: day.toString(),
            selected: daysToExpiration === day
        });
    const content = isMobileDevice ? /*#__PURE__*/ _jsxs(Select, _object_spread_props(_object_spread({}, commonSelectProps), {
        isSelected: (itemValue, currentValue)=>+itemValue === +currentValue,
        label: texts.label(),
        displayValue: hasExpirationDate ? "".concat(pluralizeDay(daysToExpiration), " after sending") : noneOption.label,
        value: hasExpirationDate ? daysToExpiration.toString() : noneOption.value,
        onChange: (e)=>{
            if (e.target.value === noneOption.value) {
                setHasExpirationDate(false);
                setDaysToExpiration(+noneOption.value);
            } else {
                setHasExpirationDate(true);
                setDaysToExpiration(+e.target.value);
            }
        },
        children: [
            /*#__PURE__*/ _jsx(MenuItem, {
                value: noneOption.value,
                selected: !hasExpirationDate,
                testId: "expiration-days-select-item-none",
                children: noneOption.label
            }),
            dayOptions().map((day)=>/*#__PURE__*/ _jsx(MenuItem, _object_spread_props(_object_spread({}, commonMenuItemProps(day)), {
                    children: pluralizeDay(day)
                }), day))
        ]
    })) : /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(WithInfoIcon, {
                info: texts.info(),
                infoTestId: "expiration-date-tooltip",
                children: /*#__PURE__*/ _jsx(Checkbox, {
                    checked: hasExpirationDate,
                    disabled: disabled,
                    onChange: (e)=>setHasExpirationDate(e.target.checked),
                    testId: "expiration-date-checkbox",
                    children: /*#__PURE__*/ _jsx(Typography, {
                        children: texts.checkboxLabel()
                    })
                })
            }),
            hasExpirationDate && /*#__PURE__*/ _jsxs(Typography, {
                className: styles.days,
                children: [
                    "The proposal expires",
                    /*#__PURE__*/ _jsx(Select, _object_spread_props(_object_spread({}, commonSelectProps), {
                        onChange: (e)=>setDaysToExpiration(+e.target.value),
                        children: dayOptions().map((day)=>/*#__PURE__*/ _jsx(MenuItem, _object_spread_props(_object_spread({}, commonMenuItemProps(day)), {
                                children: day
                            }), day))
                    })),
                    "days after sending"
                ]
            })
        ]
    });
    return /*#__PURE__*/ _jsx(GridItem, {
        span: 12,
        testId: "expiration-date",
        children: content
    });
};
export default ExpirationDate;
